// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2QUrc","header":"PatientQuestionnaire_header__2dCWA","info":"PatientQuestionnaire_info__3j-NM"};